import { useQuery } from '@tanstack/react-query';
import { getCustomerAddresses } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetCustomerAddresses = () => {
  const { isAuthenticated } = useAuthContext();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['customer-addresses'],
    queryFn: async () => {
      const response = await getCustomerAddresses();
      return response?.data;
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });

  const addresses = data?.data || [];
  const meta = data?.meta || null;

  return { data: addresses, meta, isLoading, error, refetch };
};

